const infoPayload= (type, msg, description='') => {
  return {
    info: {
      message: msg,
      type: type,
      description: description
    }
  };
}
export default infoPayload;